/*
 * @Author: 肖玲
 * @Date: 2023-02-28 16:01:31
 * @LastEditTime: 2023-10-30 13:57:59
 * @LastEditors: 刘小博
 * @Description:
 * @FilePath: \p2ps_vip_web\src\router\butterfly-flow-system\channel-delivery-manage\modules\channelDeliveryAnalyRouter.js
 * 渠道发货分析
 */
const channelDeliveryAnalyRouter = [
  // 渠道发货分析 工业发货分析
  {
    path: '/flowSystem/industrial-delivery-statistics',
    name: 'flowSystemStatisticsIndustrialDelivery',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics1" */
      //   '@/views/flowSystem/statistics/IndustrialDelivery.vue'
      // ),   待删除文件
      import(
        /*webpackChunkName:"flowSystemStatistics1" */
        '@/views/butterfly-flow-system/channel-delivery-manage/channel-delivery-analy/industrial-delivery-analy/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '渠道发货分析', //二级菜单
      title: '工业发货分析'
    }
  },
  // 渠道发货分析 工业发货分析 省份明细
  {
    path: '/flowSystem/industrial-delivery-statistics-detail',
    name: 'flowSystemStatisticsIndustrialDeliveryDetail',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics1" */
      //   '@/views/flowSystem/statistics/IndustrialDeliveryDetail.vue'
      // ),  //待删除文件
      import(
        /*webpackChunkName:"flowSystemStatistics1" */
        '@/views/butterfly-flow-system/channel-delivery-manage/channel-delivery-analy/industrial-delivery-analy/Detail.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '渠道发货分析', //二级菜单
      title: '省份明细',
      breadcrumb: [
        {
          title: '工业发货分析',
          name: 'flowSystemStatisticsIndustrialDelivery'
        }
      ]
    }
  },
  // 渠道发货分析 发货关系查询
  {
    path: '/flowSystem/delivery-relation-query-statistics',
    name: 'flowSystemStatisticsDeliveryRelationQuery',
    component: () =>
      // import(
      //   /*webpackChunkName:"flowSystemStatistics5" */
      //   '@/views/flowSystem/statistics/DeliveryRelationQuery.vue'
      // ),     待删除文件
      import(
        /*webpackChunkName:"flowSystemStatistics5" */
        '@/views/butterfly-flow-system/channel-delivery-manage/channel-delivery-analy/shipment-relation-query/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '渠道发货分析', //二级菜单
      title: '发货关系查询'
    }
  },
  // 渠道发货分析 工业发货
  {
    path: '/flowSystem/industrial-deliver',
    name: 'behaviorManageIndustrialDeliver',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageIndustrialMsgMaintain" */
      //   '@/views/behaviorManage/ditchDeliver/IndustrialDeliver.vue'
      // ),   待删除文件
      import(
        /*webpackChunkName:"behaviorManageIndustrialMsgMaintain" */
        '@/views/butterfly-flow-system/channel-delivery-manage/channel-delivery-analy/industrial-shipment/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '渠道发货分析', //二级菜单
      title: '工业发货'
    }
  },

  // 渠道发货分析 全生命周期渠道
  {
    path: '/flowSystem/full-lifecycle-channels',
    name: 'flowSystemFullLifecycleChannels',
    component: () =>
      // import(
      //   /*webpackChunkName:"behaviorManageIndustrialMsgMaintain" */
      //   '@/views/behaviorManage/ditchDeliver/IndustrialDeliver.vue'
      // ),   待删除文件
      import(
        /*webpackChunkName:"behaviorManageIndustrialMsgMaintain" */
        '@/views/butterfly-flow-system/channel-delivery-manage/channel-delivery-analy/full-lifecycle-channels/Page.vue'
      ), //新迁移文件
    meta: {
      SecondaryMenu: '渠道发货分析', //二级菜单
      title: '全生命周期渠道'
    }
  }
]
export default channelDeliveryAnalyRouter
